import { Stack, Typography } from "@mui/material";
import PercentageIndicator from "./PercentageIndicator";
import { formatearNumeroConComas } from "views/Components/Shared/utils/formatNumbers";

export default function RevenueCell({ revenue }) {
  if (!revenue) return "-";
  return (
    <Stack
      direction="column"
      spacing={0.5}
      alignItems="center"
      justifyContent="center"
      sx={{ width: "100%", height: "100%" }}
    >
      <Stack direction="row" spacing={0.5} alignItems="center">
        <Typography
          variant="body2"
          fontWeight={500}
          sx={{ color: "#00000099", fontSize: "14px" }}
        >
          ${formatearNumeroConComas(revenue?.value)}
        </Typography>
      </Stack>
      <PercentageIndicator value={revenue?.change} />
    </Stack>
  );
}
